import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';

export const BOSS_STATE = {
  NOT_DISPLAYED: 0,
  FIGHTING: 1,
  LOSE: 2,
};

const Boss = ({ state, stageNumber }) => {
  const { images } = useImagesContext();
  return (
    <>
      {state === BOSS_STATE.FIGHTING && (
        <Block src={images[`play-boss-${stageNumber}.png`]} />
      )}
      {state === BOSS_STATE.LOSE && (
        <Block src={images[`play-boss-lose-${stageNumber}.png`]} />
      )}
    </>
  );
};

const Block = styled.img`
  position: absolute;
  bottom: 10px;
  right: 165px;
`;

export default Boss;
